import React from 'react'
import Trash from '../../../../../../components/icons/Trash';
import {cnCreateForm} from '../../../FormModule';
import Edit from '../../../../../../components/icons/Edit';
import {
    ISaveCorpusFrontPlankData
} from "../../../../../../../../common-code/interfaces/saveData/ISaveCorpusFrontPlankData";
import {initialFrontPlank} from "./initialFrontPlank";
import ModalFrontPlanks from "./ModalFrontPlanks";
import {validateFrontPlank} from "./validateFrontPlank";

interface IFrontPlankProps {
    index: number;
    frontPlank: ISaveCorpusFrontPlankData;
    setArrFrontPlanks: (arr: ISaveCorpusFrontPlankData[]) => void;
    arrFrontPlanks: ISaveCorpusFrontPlankData[];
    createFrontPlank: (newFrontPlank: Record<string, string | number | boolean>) => ISaveCorpusFrontPlankData;
}

function FrontPlank({
                        index,
                        frontPlank,
                        setArrFrontPlanks,
                        arrFrontPlanks,
                        createFrontPlank
                    }: IFrontPlankProps) {

    const [modal, setModal] = React.useState<boolean>(false);
    const [newFrontPlank, setNewFrontPlank] = React.useState<Record<string, string | number | boolean>>(initialFrontPlank(frontPlank));

    const handleToggleModal = () => setModal((prev) => !prev);

    const handleDeleteFrontPlank = () =>
        setArrFrontPlanks(arrFrontPlanks.filter((el, ind) => ind !== index));

    const handleEditTable = () => {
        const error = validateFrontPlank(newFrontPlank);
        if (error) {
            setNewFrontPlank({...newFrontPlank, error});
            return;
        }
        const frontPlankEdit = createFrontPlank(newFrontPlank);
        setArrFrontPlanks(arrFrontPlanks.map((el) => el.initPosition === frontPlank.initPosition ? frontPlankEdit : el));
        setModal(false);
    }
    const {width, position} = newFrontPlank;

    const getPosition = (position: string) => {
        switch (position) {
            case 'top':
                return 'Сверху';
            case 'center':
                return 'По центру';
            case 'bottom':
                return 'Снизу';
            default:
                return 'Не определено'
        }
    }

    return (
        <div className={cnCreateForm('Children')}>
            <span>ЛДСП Планка #{index}</span>
            <span>Ширина: {width} мм</span>
            <span>Положение: {getPosition('' + position)}</span>
            <div className={cnCreateForm('Box-Btn')}>
                <Edit handleToggleModal={handleToggleModal}/>
                <Trash handleDeleteValue={handleDeleteFrontPlank}/>
            </div>

            <ModalFrontPlanks
                modal={modal}
                handleToggleModal={handleToggleModal}
                handleSubmit={handleEditTable}
                newFrontPlank={newFrontPlank}
                setNewFrontPlank={setNewFrontPlank}
                keyValue={`#editFrontPlank${index}`}
            />

        </div>
    )
}

export default FrontPlank
